module.exports = __webpack_public_path__ + "static/media/my-family-campaign-banner-desktop.1dd81a78.jpg";